module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pgbreak",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('h2', {
    staticClass: "FMO"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-FM"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/01_Ilany_Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/02_Ilany_Ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("1")]), _vm._v("Troglodytes, Hottentots, and Hebrews: The Bible and the Sources of German Anthropology")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/03_Ilany_Ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("2")]), _vm._v("The Law and the People: Mosaic Law and the German Enlightenment")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/04_Ilany_Ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("3")]), _vm._v("The Eighteenth-Century Polemic on the Extermination of the Canaanites")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Ilany_Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("4")]), _vm._v("“Is Judah Indeed the Teutonic Fatherland?” The Hebrew Model and the Birth of German National Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Ilany_Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("5")]), _vm._v("“Lovers of Hebrew Poetry”: The Battle over the Bible’s Relevance at the Turn of the Nineteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Ilany_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-BM-f"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Ilany_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-BM"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Ilany_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "pgbreak",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 75
// module chunks = 0